// ============================================================================
// FSA DOCUMENT OUTPUT PROFILE ENDPOINTS (ADR-0003)
// ============================================================================
// Backend controller: FsaDocumentOutputProfilesController → /api/v1/FsaDocumentOutputProfiles

import { buildEndpoint } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaDocumentOutputProfiles';

export const fsaDocumentOutputEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  /** GET /default — the single tenant default profile. */
  getDefault: () => buildEndpoint(`${BASE_PATH}/default`),
  /** GET /registration-types — dynamic header picker source. */
  registrationTypes: () => buildEndpoint(`${BASE_PATH}/registration-types`),
  byId: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),
  /** POST /auditor-letterhead/preview — sample auditor pages for (unsaved) Auditor's Documents settings (ADR-0024 A-2). */
  auditorLetterheadPreview: () => buildEndpoint(`${BASE_PATH}/auditor-letterhead/preview`),
};
